import { IdType, Row as RowType } from "react-table";

const normalize = (s: unknown) => {
  return String(s ?? "")
    .toLowerCase()
    .replace(/[\W_]+/g, " ");
};

export function createGlobalFilterFn<T extends object>(
  getFields: (data: T) => unknown[],
) {
  return (
    rows: Array<RowType<T>>,
    _columnIds: Array<IdType<T>>,
    filterValue: any,
  ): Array<RowType<T>> => {
    if (
      filterValue === undefined ||
      (typeof filterValue === "string" && filterValue.trim() === "")
    ) {
      return rows;
    }
    const queryTokens = normalize(filterValue).split(" ").filter(Boolean);
    if (queryTokens.length === 0) {
      return rows;
    }
    return rows.filter((row) =>
      getFields(row.original)
        .filter(
          (v) => v != null && typeof v !== "object" && typeof v !== "function",
        )
        .some((v) => {
          const normalized = normalize(v);
          return queryTokens.every((token) => normalized.includes(token));
        }),
    );
  };
}
